import React, {Component} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane, Input,
} from 'reactstrap';
import {Colxx} from '../components/common/CustomBootstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {NotificationManager} from "../components/common/react-notifications";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {getDatePickerProps} from "../helpers/Utils";
import {find, keyBy, reduce} from "lodash";
import LoaderButton from '../components/LoaderButton';
import FieldError from "../components/FieldError";
import TextField from '../components/TextField';
import {required} from "../helpers/Validators";
import {withTranslation} from 'react-i18next';
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import fa_IR from "../constants/locales";
import classnames from "classnames";
import i18n from "../services/i18n";
import Api from "../services/Api";
import Select from "react-select";
import moment from "moment";

class CreateNotificationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: {},
      groups: [],
      typeOptions: [],
      groupOptions: [],
      userGroupsOptions: [
        {label: 'ALL_USERS', value: 'ALL'},
      ],
      recipientTypeOptions: [
        {label: 'GROUP', value: 'GROUP'},
        {label: 'USER', value: 'USER'},
      ],
      priorityOptions: Array.from(Array(10).keys()).map(item => {
        return {label: item + 1, value: item + 1};
      }),
    };
  }

  async componentDidMount() {
    await Promise.all([
      this.fetchTypes(),
      this.fetchGroups(),
    ]);
  }

  fetchTypes = async () => {
    const {category} = this.props;
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/types', null, {
        params: {
          category,
        },
      });
      this.setState({
        types: keyBy(data.rows, 'type'),
        typeOptions: data.rows.map(item => ({label: item.type, value: item.type})),
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  fetchGroups = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/groups');
      this.setState({
        groups: data.rows,
        groupOptions: data.rows.map(item => ({label: item.name, value: item.name})),
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  createNotification = async (values, form) => {
    const {types} = this.state;
    const {t, category} = this.props;
    const {recipientType, recipient, type, priority, groups, expireTime,} = values;
    try {
      await Api.invoke('POST', `/v2/admin-ui/notifications`, {
        category,
        type: type.value,
        recipient: {
          type: recipientType.value,
          value: recipientType.value === 'GROUP' ? recipient.value : recipient,
        },
        actionFlow: types[type.value]["actionFlow"].map(obj => ({
          channel: obj.channel,
          presentation: {
            ...(obj.presentation.data.settings.enabled ? {
              data: {
                ...reduce(obj.presentation.data.keys, (res, item) => {
                  return {
                    ...res,
                    [item]: values[`${obj.channel}_data_${item}`],
                  };
                }, {}),
              }
            } : null),
            ...(obj.presentation.message.settings.enabled ? {
              message: {
                ...reduce(obj.presentation.message.keys, (res, item) => {
                  return {
                    ...res,
                    [item]: values[`${obj.channel}_message_${item}`],
                  };
                }, {}),
              }
            } : null),
          }
        })),
        ...(priority ? {priority: priority.value} : null),
        ...(groups ? {groups: groups.map(item => item.value)} : null),
        ...(expireTime ? {expiredAt: moment(expireTime).toISOString()} : null),
      });
      NotificationManager.success(t('Notification created successfully'), t('Message'));
      setTimeout(form.restart);
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateNotification = async values => {
    const {types} = this.state;
    const {t, notification} = this.props;
    const {recipientType, recipient, priority, groups} = values;
    try {
      const newNotification = {
        ...(priority ? {priority: priority.value} : null),
        ...(groups ? {groups: groups.map(item => item.value)} : null),
        ...(notification.status === "DRAFT" ? {
          recipient: {
            type: recipientType.value,
            value: recipientType.value === 'GROUP' ? recipient.value : recipient,
          },
        } : null),
        ...(notification.status === "DRAFT" ? {
          actionFlow: types[notification.type]["actionFlow"].map(obj => ({
            channel: obj.channel,
            presentation: {
              ...(obj.presentation.data.settings.enabled ? {
                data: {
                  ...reduce(obj.presentation.data.keys, (res, item) => {
                    return {
                      ...res,
                      [item]: values[`${obj.channel}_data_${item}`],
                    };
                  }, {}),
                }
              } : null),
              ...(obj.presentation.message.settings.enabled ? {
                message: {
                  ...reduce(obj.presentation.message.keys, (res, item) => {
                    return {
                      ...res,
                      [item]: values[`${obj.channel}_message_${item}`],
                    };
                  }, {}),
                }
              } : null),
            }
          })),
        } : null),
      };
      await Api.invoke('PATCH', `/v2/admin-ui/notifications/${notification.id}`, newNotification);
      NotificationManager.success(t('Notification updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  SelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  MultiSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  getInitialValues = () => {
    const {notification} = this.props;
    const {userGroupsOptions, groupOptions, typeOptions, recipientTypeOptions} = this.state;
    if (notification) {
      const {status, recipient, groups, priority, type, expiredAt, actionFlow} = notification;
      if (status === "DRAFT") {
        return {
          activeTab: 0,
          status: "DRAFT",
          type: find(typeOptions, {value: type}),
          recipientType: find(recipientTypeOptions, {value: recipient.type}),
          recipient: recipient.type === 'GROUP' ? find(userGroupsOptions, {value: recipient.value}) : recipient.value,
          ...(groups ? {groups: groups.map(item => find(groupOptions, {value: item}))} : null),
          ...(priority ? {priority: {label: priority, value: priority}} : null),
          ...(expiredAt ? {expireTime: moment(expiredAt)} : null),
          ...reduce(actionFlow, (otherValues, obj) => {
            const {channel, presentation} = obj;
            const {data, message} = presentation;
            return {
              ...otherValues,
              ...reduce(data, (res, value, key) => {
                return {
                  ...res,
                  [`${channel}_data_${key}`]: value,
                };
              }, {}),
              ...reduce(message, (res, value, key) => {
                return {
                  ...res,
                  [`${channel}_message_${key}`]: value,
                };
              }, {}),
            };
          }, {}),
        };
      }
      return {
        activeTab: 0,
        ...(groups ? {groups: groups.map(item => find(groupOptions, {value: item}))} : null),
      };
    }
    return {
      activeTab: 0,
      status: "DRAFT",
    };
  };

  render() {
    const {t, notification} = this.props;
    const {types, typeOptions, groupOptions, userGroupsOptions, recipientTypeOptions, priorityOptions} = this.state;
    return (
      <MuiPickersUtilsProvider
        utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
        locale={i18n.language}>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {!notification ? t('Create Notification') : t('Edit Notification')}
                </CardTitle>
                <FinalForm
                  initialValues={this.getInitialValues()}
                  onSubmit={!notification ? this.createNotification : this.updateNotification}
                  render={({form, handleSubmit, submitting, pristine, hasValidationErrors, values}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row className="pt-3">
                          <Col className="col-lg-5 col-md-12">
                            <div className="text-one font-weight-semibold mb-4 mt-lg-0 mt-4">
                              {t("Settings")}:
                            </div>
                            {!notification &&
                              <Row className="mb-3">
                                <Col>
                                  <span>{t('Notification Type')}<span className="required">*</span></span>
                                  <Field
                                    name="type"
                                    options={typeOptions}
                                    component={this.SelectAdapter}
                                    validate={required}
                                  />
                                  <FieldError name='type'/>
                                </Col>
                              </Row>
                            }
                            {values.status === "DRAFT" &&
                              <Row className="mb-3">
                                <Col>
                                  <span>{t('Recipient Type')}<span className="required">*</span></span>
                                  <Field
                                    name="recipientType"
                                    options={recipientTypeOptions}
                                    component={this.SelectAdapter}
                                    validate={required}
                                  />
                                  <FieldError name='recipientType'/>
                                </Col>
                              </Row>
                            }
                            {values.status === "DRAFT" && !!values.recipientType && values.recipientType.value === "GROUP" &&
                              <Row className="mb-3">
                                <Col>
                                  <span>{t('User Groups')}<span className="required">*</span></span>
                                  <Field
                                    name="recipient"
                                    options={userGroupsOptions}
                                    component={this.SelectAdapter}
                                    validate={required}
                                  />
                                  <FieldError name='recipientType'/>
                                </Col>
                              </Row>
                            }
                            {values.status === "DRAFT" && !!values.recipientType && values.recipientType.value === "USER" &&
                              <Row className="mb-2">
                                <Col>
                                  <TextField
                                    item={{
                                      name: 'recipient',
                                      i18n: t('User Id'),
                                      type: 'text',
                                      required: true,
                                    }}
                                  />
                                </Col>
                              </Row>
                            }
                            {values.status === "DRAFT" &&
                              <Row className="mb-3">
                                <Col>
                                  <span>{t('Send Priority')}</span>
                                  <Field
                                    name="priority"
                                    options={priorityOptions}
                                    component={this.SelectAdapter}
                                  />
                                  <FieldError name='priority'/>
                                </Col>
                              </Row>
                            }
                            <Row className="mb-3">
                              <Col>
                                <span>{t('Groups')}</span>
                                <Field
                                  name="groups"
                                  options={groupOptions}
                                  component={this.MultiSelectAdapter}
                                />
                                <FieldError name='groups'/>
                              </Col>
                            </Row>
                            {values.status === "DRAFT" &&
                              <Row className="mb-3">
                                <Col>
                                  <span>{t('Expiration Date')}</span>
                                  <Field name="expireTime">
                                    {({input}) => (
                                      <DateTimePicker
                                        {...getDatePickerProps()}
                                        minDate={moment()}
                                        maxDate={undefined}
                                        value={input.value ? input.value : null}
                                        onChange={date => {
                                          if (moment(date) >= moment()) {
                                            input.onChange(date);
                                          } else {
                                            alert(t("The selected time must be ahead of the current time."));
                                          }
                                        }}
                                        TextFieldComponent={props =>
                                          <Input
                                            style={{width: '100%'}}
                                            placeholder={t('Select')}
                                            {...props}
                                          />
                                        }
                                      />
                                    )}
                                  </Field>
                                </Col>
                              </Row>
                            }
                          </Col>
                          {values.status === "DRAFT" && !!values.type && !!types[values.type.value] && types[values.type.value]["actionFlow"].length > 0 &&
                            <Col className="col-lg-6 col-12 ml-lg-5 ml-0">
                              <div className="text-one font-weight-semibold mb-4 mt-lg-0 mt-4">
                                {t("Content")}:
                              </div>
                              <Row className="mb-2">
                                <Col>
                                  <Nav tabs>
                                    {types[values.type.value]["actionFlow"].map((item, index) => {
                                      return (
                                        <NavItem key={item.channel}>
                                          <NavLink
                                            className={classnames({active: values.activeTab === index})}
                                            onClick={() => {form.change("activeTab", index);}}>
                                            <span className="text-one cursor-pointer">{item.channel}</span>
                                          </NavLink>
                                        </NavItem>
                                      );
                                    })}
                                  </Nav>
                                  <TabContent activeTab={values.activeTab} className="mt-2">
                                    {types[values.type.value]["actionFlow"].map((item, index) => {
                                      const {data, message} = item.presentation;
                                      return (
                                        <TabPane tabId={index}>
                                          {message.settings.enabled && message.keys.length > 0 &&
                                            <div>
                                              <div className="text-info mb-2">
                                                {t("Display Info")}:
                                              </div>
                                              {message.keys.map(fieldName => (
                                                <Row key={fieldName}>
                                                  <Col>
                                                    <TextField
                                                      item={{
                                                        name: `${item.channel}_message_${fieldName}`,
                                                        i18n: fieldName,
                                                        type: 'textarea',
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              ))}
                                            </div>
                                          }
                                          {data.settings.enabled && data.keys.length > 0 &&
                                            <div className="mb-4">
                                              <div className="text-info mb-2">
                                                {t("Meta Info")}:
                                              </div>
                                              {data.keys.map(fieldName => (
                                                <Row key={fieldName}>
                                                  <Col>
                                                    <TextField
                                                      item={{
                                                        name: `${item.channel}_data_${fieldName}`,
                                                        i18n: fieldName,
                                                        type: 'textarea',
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              ))}
                                            </div>
                                          }
                                        </TabPane>
                                      );
                                    })}
                                  </TabContent>
                                </Col>
                              </Row>
                            </Col>
                          }
                        </Row>
                        <div className="mt-5 d-flex flex-row align-items-center">
                          <LoaderButton
                            size="xl"
                            loading={submitting}
                            onClick={handleSubmit}
                            disabled={pristine || hasValidationErrors || submitting}
                            style={{minWidth: '100px'}}
                            className="text-center">
                            {t('Save')}
                          </LoaderButton>
                        </div>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </MuiPickersUtilsProvider>
    );
  }
}

export default withTranslation()(CreateNotificationForm);
